import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {useNavigate} from 'react-router-dom'



import "./Sales.css"
import { FaHouseUser, FaUserPlus, FaHandshake, FaHome , FaArrowLeft } from 'react-icons/fa';
import axios from 'axios';
import Sidebar from '../../components/Sidebar';
import {salesConfig} from "./../../components/PageConfig"

const Sales = () => {
    const navigate = useNavigate()


        return(
            <Sidebar menuItems = {salesConfig} >
            <main id='sales-container' >
                
                    <section className='sales-group-card' >
                    

                        <h1>Sales</h1>

                    </section>
                
                
            </main>
            </Sidebar>
        )
    


}

export default Sales;